/**
 * Created context for tooltips to avoid passing handlers all the way down
 *
 * Manages shared tooltip state so only one tooltip open at a time
 */
import { createContext, useContext, useState, ReactNode } from "react";

type InstructionEditorTooltipContextType = {
	activeId: string | null;
	setActiveId: (id: string | null) => void;
};

const InstructionEditorTooltipContext = createContext<InstructionEditorTooltipContextType | undefined>(undefined);

export function InstructionEditorTooltipProvider({ children }: { children: ReactNode }) {
	const [activeId, setActiveId] = useState<string | null>(null);
	return (
		<InstructionEditorTooltipContext.Provider value={{ activeId, setActiveId }}>
			{children}
		</InstructionEditorTooltipContext.Provider>
	);
}

export function useInstructionEditorTooltipContext() {
	const context = useContext(InstructionEditorTooltipContext);
	if (!context) {
		throw new Error("useInstructionEditorTooltipContext must be used within an InstructionEditorTooltipProvider");
	}
	return context;
}
